var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("search-form", {
    attrs: {
      enablePredictiveSearch: _vm.enablePredictiveSearch,
      placeholder: _vm.placeholder
    },
    on: { "close-search": _vm.closeSearch }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }